export default {
  soulPalace: 'soul',
  bodyPalace: 'body',
  siblingsPalace: 'siblings',
  spousePalace: 'spouse',
  childrenPalace: 'children',
  wealthPalace: 'wealth',
  healthPalace: 'health',
  surfacePalace: 'surface',
  friendsPalace: 'friends',
  careerPalace: 'career',
  propertyPalace: 'property',
  spiritPalace: 'spirit',
  parentsPalace: 'parents',
  originalPalace: 'origin',
} as const;
